import AXIOS from "@/axios";
import { APIResponse } from "@/types";
import { removeEmptyProps } from "@/utils/constants";
import moment from "moment";
import {
  DownloadStudentLogQuery,
  StudentLogModel,
  StudentLogQuery,
} from "../types/student-log.model";

/**
 * Get all student logs with pagination and filtering
 */
export const getAllStudentLogsService = async (
  query: StudentLogQuery // Prefixed with underscore to indicate it's intentionally unused
): Promise<{
  data: APIResponse<StudentLogModel[]>;
}> => {
  if (query.fromDate && query.toDate) {
    query.fromDate = moment(new Date(query.fromDate).toISOString()).format(
      "DD-MM-YYYY"
    );
    query.toDate = moment(new Date(query.toDate).toISOString()).format(
      "DD-MM-YYYY"
    );
  }

  return AXIOS.get<APIResponse<StudentLogModel[]>>(
    "/auth/api/v1/stdnt/logs/list",
    {
      params: removeEmptyProps(query),
    }
  );
};

export const downloadStudentLogService = async (
  type: "pdf" | "xl" | "csv",
  params: DownloadStudentLogQuery
) => {
  if (params.fromDate && params.toDate) {
    params.fromDate = moment(new Date(params.fromDate).toISOString()).format(
      "DD-MM-YYYY"
    );
    params.toDate = moment(new Date(params.toDate).toISOString()).format(
      "DD-MM-YYYY"
    );
  }

  return AXIOS.get<{ message: string }>(
    `/auth/api/v1/stdnt/logs/dwnld/${type}`,
    {
      params: removeEmptyProps(params),
      responseType: "blob",
    }
  );
};
